import {
  GET_SCHOOLS,
  GET_SCHOOLS_SUCCESS,
  GET_SCHOOLS_ERROR,
  UPDATE_SELECTED_SCHOOL_LEVEL,
} from "./actions";
import { schoolState } from "./state";
import { map, uniq, cloneDeep, filter } from "lodash";

export const initialSchoolsState = {
  data: {
    schoolLevels: null,
    schools: null,
    selectedSchoolLevel: null,
    currentlyFilteredSchools: null,
  },
  pending: null,
  error: null,
};

//remember to avoid mutation within reducers
export function schools(state = initialSchoolsState, Actions): schoolState {
  switch (Actions.type) {
    case GET_SCHOOLS:
      return Object.assign({}, state, { pending: true, error: null });
    case GET_SCHOOLS_SUCCESS:
      let schoolLevels = uniq(map(Actions.payload, "schoolLevel"));
      schoolLevels.unshift("All");
      let data = {
        schools: Actions.payload,
        schoolLevels,
        selectedSchoolLevel: "All",
        currentlyFilteredSchools: Actions.payload,
      };
      return Object.assign({}, state, { data, pending: false });
    case GET_SCHOOLS_ERROR:
      return Object.assign({}, state, { pending: false, error: "Error" });
    case UPDATE_SELECTED_SCHOOL_LEVEL:
      let newFilteredSchools =
        Actions.payload == "All"
          ? cloneDeep(state.data.schools)
          : filter(state.data.schools, ["schoolLevel", Actions.payload]);
      return Object.assign({}, state, {
        data: {
          ...state.data,
          selectedSchoolLevel: Actions.payload,
          currentlyFilteredSchools: newFilteredSchools,
        },
      });
    default:
      return state;
  }
}
